<template>
  <div class="col">
    <label :for="identifier">{{ label }}</label>
    <div class="w-50">
      <input
        :id="identifier"
        type="file"
        @change="uploadImage"
        :ref="fileRef"
        class="form-control"
        accept="image/*"
      />
      <div v-if="isSubmit && errorImage" class="text-error">
        {{ errorImage.message }}
      </div>
    </div>
    <div class="d-flex justify-content-start align-items-center gap-3 pt-5">
      <img v-if="imageSrc" :src="imageSrc" alt="" class="preview-image" />
      <button
        v-if="imageSrc && deleteImage"
        class="btn btn-outline-danger btn-del"
        @click="deleteImage"
      >
        Delete
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "UploadAndPreviewImage",
  props: {
    label: {
      type: String,
      default: () => null,
    },
    fileRef: {
      type: File,
      default: () => null,
    },
    imageSrc: {
      type: String,
      default: () => null,
    },
    uploadImage: {
      type: Function,
    },
    deleteImage: {
      type: Function,
    },
    errorImage: {
      type: Object,
      default: () => {},
    },
    isSubmit: {
      type: Boolean,
      default: () => false,
    },
    identifier: {
      type: String,
      default: () => null,
    },
  },
};
</script>
<style lang="scss" scoped>
.preview-image {
  max-width: 300px;
  height: auto;
}
</style>
